import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function Headerbar()
{
    return (
        <>
        <Navbar bg="transparent" variant="light">
        <Container>
          <Navbar.Brand href="/">Cloudflare General Assignment</Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link href="/visualizetraffic">Visualize Traffic</Nav.Link>
            <Nav.Link href="/displayranking">Display Rankings</Nav.Link>
            <Nav.Link href="/visualizeddosattacks">Visualize DDos Attacks</Nav.Link>
          </Nav>
        </Container>
      </Navbar>
      </>
    )
}

export default Headerbar;